import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { AboutPage } from './pages/AboutPage';
import { BoardExperiencePage } from './pages/BoardExperiencePage';
import { ExpertisePage } from './pages/ExpertisePage';
import { ExperiencePage } from './pages/ExperiencePage';
import { ResultsPage } from './pages/ResultsPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31ayrk56alu0v">
      <ScrollToTop data-id="element-1" data-mp="31bi9vmzuukff" />
      <div className="flex min-h-full w-full flex-col bg-white font-sans" data-id="element-2" data-mp="31c1iue7j1yhb">
        <Header data-id="element-3" data-mp="2wj8ehrfz0s5r" />
        <main className="flex-1" data-id="element-4" data-mp="2wip54z4dzc3c">
          <Routes data-id="element-5" data-mp="28ufm24yk52fw">
            <Route path="/" element={<Home data-id="element-7" data-mp="28t4l0cwhy8sh" />} data-id="element-6" data-mp="28tmex2vosax8" />
            <Route path="/about" element={<AboutPage data-id="element-9" data-mp="23vkwmk634fmt" />} data-id="element-8" data-mp="28sbbj465l56n" />
            <Route path="/board-experience" element={<BoardExperiencePage data-id="element-11" data-mp="23t8hsfvmildz" />} data-id="element-10" data-mp="23u9t8lgjx9w8" />
            <Route path="/expertise" element={<ExpertisePage data-id="element-13" data-mp="3ij668fcdfvai" />} data-id="element-12" data-mp="3ikh8ubu2yx01" />
            <Route path="/experience" element={<ExperiencePage data-id="element-15" data-mp="3ml1397n9rmih" />} data-id="element-14" data-mp="3ihuyy5jpw5en" />
            <Route path="/results" element={<ResultsPage data-id="element-17" data-mp="3mj6ipufwtwex" />} data-id="element-16" data-mp="3mk83wrqn3zad" />
            <Route path="/contact" element={<ContactPage data-id="element-19" data-mp="3rdkg22e4udm8" />} data-id="element-18" data-mp="3rbrakqf99zft" />
            <Route path="*" element={<Home data-id="element-21" data-mp="5otf64sd496" />} data-id="element-20" data-mp="3recctgjguhe3" />
          </Routes>
        </main>
        <Footer data-id="element-22" data-mp="5gbgztt38r4" />
      </div>
    </BrowserRouter>;
}